// Linear-backoff retry wrapper for transient network failures. Mobile carriers
// — especially iOS Safari resuming from background — frequently kill the first
// request and succeed on retry. Skips retry on 4xx (validation/auth) so those
// fail fast instead of pinning the user behind a stuck spinner.
//
// Usage: const res = await retryAsync(() => $apiV2.get(...));
export const retryAsync = async (fn, retries = 2, baseDelayMs = 1500) => {
  let lastErr;
  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      return await fn();
    } catch (err) {
      lastErr = err;
      const status = err?.response?.status;
      if (status != null && status >= 400 && status < 500) throw err;
      if (attempt < retries) {
        await new Promise((r) => setTimeout(r, baseDelayMs * (attempt + 1)));
      }
    }
  }
  throw lastErr;
};

export default retryAsync;
